import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { User, Mail, AlertCircle, CheckCircle } from 'lucide-react';
import { auth } from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sentMessage, setSentMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await auth.forgotPassword(email);
      setSentMessage(response.data.message);
    } catch (err) {
      setError('Não foi possível enviar o pedido. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-100 via-brand-50 to-coral-100 px-4">
      <div className="backdrop-blur-lg bg-white/70 rounded-2xl shadow-2xl p-10 w-full max-w-md flex flex-col items-center">
        <div className="h-16 w-16 bg-brand-100 rounded-full flex items-center justify-center mb-4">
          <Mail className="h-8 w-8 text-brand-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Esqueceu sua senha?</h1>

        {sentMessage ? (
          <div className="w-full mt-4 bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-md text-sm flex items-start">
            <CheckCircle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
            <div>
              <p>{sentMessage}</p>
              <p className="mt-2 text-xs">
                O link expira em 60 minutos. Se não encontrar o email, verifique sua caixa de spam ou fale com o administrador da sua organização.
              </p>
            </div>
          </div>
        ) : (
          <form className="w-full space-y-5" onSubmit={handleSubmit}>
            <p className="text-sm text-gray-600 text-center">
              Informe seu email e enviaremos um link para você escolher uma nova senha.
            </p>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm flex items-start">
                <AlertCircle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
                <span>{error}</span>
              </div>
            )}

            <div>
              <label htmlFor="email" className="sr-only">Email</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <User className="h-5 w-5 text-gray-400" />
                </span>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-lg border border-gray-300 pl-10 pr-3 py-3 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-brand-400 bg-white/80"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 rounded-lg bg-brand-700 hover:bg-brand-800 text-white font-semibold shadow-md transition-all duration-150 disabled:bg-brand-400"
            >
              {loading ? 'Enviando...' : 'Enviar link'}
            </button>
          </form>
        )}

        <Link to="/login" className="mt-6 text-sm text-brand-600 hover:text-brand-800 font-medium">
          Voltar para o login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
